@for (element of elements(); track element.text) {
  <app-item [element]="element" [instancesComponent]="instancesComponent()" />
}
